<template>
  <ul
    class="scrollbar-h-px extend-width mb-6 flex w-full overflow-y-hidden overflow-x-scroll desktop:flex-wrap desktop:overflow-x-hidden"
    role="tablist"
  >
    <li v-for="(tab, index) in tabs" :key="tab" class="mr-2 desktop:mb-2">
      <button
        class="w-full whitespace-nowrap rounded-full border border-solid px-4 py-2 text-sm font-bold transition tablet:text-base"
        :class="
          model === index
            ? 'border-blue-400 bg-blue-400 text-white'
            : 'border-gray-400 bg-white text-blue-400 hover:border-blue-400'
        "
        :title="tab"
        @click="model = index"
      >
        {{ tab }}
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
  interface IProps {
    tabs: string[];
  }

  defineProps<IProps>();
  const model = defineModel<number>({ default: 0 });
</script>
